import type { LOAN_REQUEST_OFFER_SOURCES } from 'cpool-constants';
import { useTranslation } from 'react-i18next';
import { HiOutlineDocumentCurrencyEuro } from 'react-icons/hi2';

import { CreditWorthinessDialog } from './CreditWorthinessDialog';
import type { AcceptedOfferSource } from '~/features/leadDetails/components/BankCreditRequest/NewCreditRequest/RequestConfiguration/types';
import { LEAD_DETAILS_OVERLAYS } from '~/features/leadDetails/constants/overlays';
import { useLeadDetailsOverlayState } from '~/features/leadDetails/hooks/useLeadDetailsOverlayState';

type CreditWorthinessOffer = Extract<
    AcceptedOfferSource,
    { source: typeof LOAN_REQUEST_OFFER_SOURCES.EUROPACE | typeof LOAN_REQUEST_OFFER_SOURCES.EUROPACE_SYNC }
>;

type Props = CreditWorthinessOffer & {
    offerId: string;
    routeControlled?: boolean;
    withLabel?: boolean;
};

export const CreditWorthinessButton = ({
    offerId,
    routeControlled = false,
    withLabel = false,
    ...acceptedOffer
}: Props) => {
    const { t } = useTranslation();
    const { isOpen, setOpen } = useLeadDetailsOverlayState({
        isRouteControlled: routeControlled,
        key: LEAD_DETAILS_OVERLAYS.CREDIT_WORTHINESS_ID,
        value: offerId,
    });

    return (
        <>
            <button
                aria-label={t('OFFER_MANAGEMENT.ICONS_TOOLTIP.HOUSEHOLD_BUDGET')}
                type="button"
                onClick={() => setOpen(true)}
                className="flex items-center gap-2 w-full cursor-pointer"
            >
                <HiOutlineDocumentCurrencyEuro size={16} data-testid="house-hold-calculations-icon" />
                {withLabel && (
                    <span className="text-xs px-3">{t('OFFER_MANAGEMENT.ICONS_TOOLTIP.HOUSEHOLD_BUDGET')}</span>
                )}
            </button>
            {!routeControlled && (
                <CreditWorthinessDialog {...acceptedOffer} isOpen={isOpen} onClose={() => setOpen(false)} />
            )}
        </>
    );
};
